import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import { PlanningApplicationSearchState } from "@publicPortal/pages/search/PlanningApplication/PlanningApplicationSearchState";

const { initialSearchState: pasInitialState, initialFilterState: pasInitialFilter } = PublicPortalState.planningApplicationInitialSearchState();

export interface PlanningApplicationsSearchSlice {
    planningApplicationsSearch: PlanningApplicationSearchState;
    setPlanningApplicationsSearch: (state: PlanningApplicationSearchState) => void;
    updatePlanningApplicationsSearch: (partialState: Partial<PlanningApplicationSearchState>) => void;
    updatePlanningApplicationsFilter: (partialFilter: Partial<PlanningApplicationSearchState["filter"]>) => void;
    resetPlanningApplicationsFilter: () => void;
}

export const createPlanningApplicationsSearchSlice: StateCreator<PlanningApplicationsSearchSlice, [], [], PlanningApplicationsSearchSlice> = (set) => ({
    planningApplicationsSearch: pasInitialState,
    setPlanningApplicationsSearch: (state) => set({ planningApplicationsSearch: state }),
    updatePlanningApplicationsSearch: (partialState) =>
        set((state) => ({ planningApplicationsSearch: { ...state.planningApplicationsSearch, ...partialState } })),
    updatePlanningApplicationsFilter: (partialFilter) =>
        set((state) => ({
            planningApplicationsSearch: { ...state.planningApplicationsSearch, filter: { ...state.planningApplicationsSearch.filter, ...partialFilter } },
        })),
    resetPlanningApplicationsFilter: () =>
        set((state) => ({ planningApplicationsSearch: { ...state.planningApplicationsSearch, filter: { ...pasInitialFilter } } })),
});

